import { PurchaseOrderBundle } from '@/services/api/contracts/catalog/bundles';
import { useDeviceFeeById } from '@/utils/deviceFee';
import { usePurchaseOrderDetails } from '../../usePurchaseOrderDetails';
import { PurchaseOrderCompleteDocumentTableData } from './PurchaseOrderCompleteDocumentTable';

export const useBuildPurchaseOrderCompleteDocumentTableData = (order: PurchaseOrderBundle) => {
  const { products } = usePurchaseOrderDetails(order);
  const deviceFee = useDeviceFeeById(
    order.deviceFeeCatalogItem?.id,
    order.submittedOn ? new Date(order.submittedOn) : undefined
  );

  return products.map(product => {
    const price = product.price?.price ?? 0;
    const qty = order.bundledItems.find(item => item.catalogItem === product.id)?.count;
    const totalPrice = price * (qty ?? 1);

    const model = product.category.isMainDevice
      ? order.financeModels?.find(
          model => model.categoryId === product.category.id && model.manufacturerId === product.manufacturer.id
        )
      : order.peripheralFinanceModel;

    const pcmPrice = totalPrice * (model ? model.pcmFactor : 0);

    return {
      name: product.name,
      product: product,
      qty,
      price,
      totalPrice,
      pcmPrice,
      deviceFee: deviceFee !== undefined && product.category.isMainDevice ? deviceFee.price?.price ?? 0 : undefined
    } as PurchaseOrderCompleteDocumentTableData;
  });
};
